var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 66,
    viewBox: "0 0 57 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1719 58.6221L26.4707 37.9082L26.9717 37.0645L27.9209 36.8135L49.9414 30.9834L3.38184 4.66699L14.1719 58.6221Z",
    fill: "#A251FF",
    stroke: "white",
    strokeWidth: 4.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerFinance);
export default __webpack_public_path__ + "static/media/pointer-finance.c4416245564a34f0d86009c59bb6d8e5.svg";
export { ForwardRef as ReactComponent };